export default function WhatIsSection() {
  const comparisonRows = [
    { feature: 'Finding Products', traditional: 'Hours of manual searching across platforms', spreadsheet: 'Curated database with instant access' },
    { feature: 'Organization', traditional: 'Scattered bookmarks and notes', spreadsheet: 'Organized by category with easy filtering' },
    { feature: 'Time Efficiency', traditional: 'Weeks to build a decent list', spreadsheet: 'Ready to use in seconds' },
    { feature: 'Category Filtering', traditional: 'No systematic filtering', spreadsheet: '14+ categories with clear navigation' },
    { feature: 'Product Comparison', traditional: 'Manual side-by-side research', spreadsheet: 'Structured data for easy comparison' },
  ];

  return (
    <section id="what-is" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-4 tracking-wide">UNDERSTAND THE TOOL</span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            What Is <span className="text-primary-500">Kakobuy Spreadsheet</span>?
          </h2>
          <p className="mt-4 text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Kakobuy Spreadsheet is a carefully curated product database designed to help shoppers discover trending products faster and more efficiently than traditional browsing.
          </p>
        </div>

        <div className="max-w-5xl mx-auto bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="p-6 md:p-8">
            <p className="text-foreground-700 leading-relaxed mb-6">
              In the world of online shopping, finding the right products can feel overwhelming. The <strong>Kakobuy Spreadsheet</strong> solves this by organizing thousands of verified product finds into a single, easy-to-navigate database. Whether you are hunting for the latest sneakers, stylish hoodies, or unique accessories, this spreadsheet puts every item at your fingertips.
            </p>

            <h3 className="text-lg font-heading font-bold text-foreground-950 mb-4">
              Traditional Searching vs Kakobuy Spreadsheet
            </h3>

            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left py-3 px-4 text-foreground-700 font-semibold whitespace-nowrap">Feature</th>
                    <th className="text-left py-3 px-4 text-foreground-600 font-medium whitespace-nowrap">Traditional Search</th>
                    <th className="text-left py-3 px-4 text-primary-600 font-medium whitespace-nowrap">Kakobuy Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonRows.map((row, i) => (
                    <tr key={row.feature} className={`border-b border-background-200/50 ${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                      <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">{row.feature}</td>
                      <td className="py-3 px-4 text-foreground-500">{row.traditional}</td>
                      <td className="py-3 px-4 text-primary-700 font-medium">{row.spreadsheet}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}